import { useTranslation } from "react-i18next";
import { ShowMessageDialog } from "../common/utils/dialogUtlities";
import { useMemo, useState } from "react";
import { makeBeaconRequest, useBeaconRequest } from "../reducers/beaconSlice";
import useNetwork from "../common/hooks/networkHook";
import Button from "../common/components/Button";
import Icon from "../common/components/Icon";
import { FormDialog } from "../common/components/CustomForm";

const BeaconButton = ({ id: key, kind }) => {
    const { t } = useTranslation();
    const network = useNetwork();
    const [pendingAction, setPendingAction] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showFailure, setShowFailure] = useState(false);
    const beaconRequest = useBeaconRequest(kind, key);

    const formDef = useMemo(() => [
        {
            borderless: true,
            rows: [
                [ { type: "label", text: t('beaconRequestDetails') }],
                [ { type: "phone", field: "mobile", label: t('mobile'), colspan: 12, required: true} ],
            ]
        }
    ], [t]);

    const doRequest = result => {
        makeBeaconRequest(network, { kind, key, mobile: result.mobile}).then(() => setShowSuccess(true), () => setShowFailure(true))
    }

    return <>
        <FormDialog showModal={pendingAction} def={formDef} value={{}} title={t('beaconRequestLocation')} onClose={result => {
            setPendingAction(false);
            if (result) {
                doRequest(result);
            } else {
                setPendingAction(false);
            }
        }}></FormDialog>
        <ShowMessageDialog showModal={showSuccess} title={t('beaconRequestSentTitle')} message={t('beaconRequestSentMessage', { mobile: '', kind })} onClose={() => setShowSuccess(false)}></ShowMessageDialog>
        <ShowMessageDialog showModal={showFailure} title={t('beaconRequestFailedTitle')} message={t('beaconRequestFailedMessage')} onClose={() => setShowFailure(false)}></ShowMessageDialog>
        <Button variant="default" layout="stacked" disabled={!!beaconRequest} onClick={() => setPendingAction(true)}>
            <Icon variant="regular" kind="compass"></Icon> {beaconRequest ? t('pending') : t('beacon')}
        </Button>
    </>
}

export default BeaconButton;